<script setup>
const { lenis } = useLenis()
const route = useRoute()

provide('lenis', lenis)

watch(
  () => route.name,
  () => {
    lenis.value.scrollTo(0, { immediate: true })
  },
)
</script>

<template>
  <div>
    <NuxtLayout>
      <NuxtLoadingIndicator :color="'#000'" />
      <VitePwaManifest />
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>